import * as Yup from "yup";
import {t} from "i18next";

export type NewCommonForm = {
    companyId: number | null;
    auctionType: { value: string, label: string };
    deliveryType: { id: number | null, label: string } | null
    deliveryDate: Date | null;
    auctionDate: Date | null;
    year: number | null;
    productType:  { value: string, label: string };
}

export const initialValues: NewCommonForm = {
    companyId: null,
    auctionType: {value: "", label: ""},
    deliveryType: null,
    deliveryDate: null,
    auctionDate: null,
    year: new Date().getFullYear(),
    productType: {value: "", label: ""},
};

export function ValidationSchema() {
    return Yup.object({
        companyId: Yup.number()
            .required(t("validation.required")),
        auctionType: Yup.object({
            value: Yup.string().required(t("validation.required")),
        }),
        year: Yup.number()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        deliveryType: Yup.object({
            id: Yup.number()
                .typeError(t("validation.required"))
                .required(t("validation.required"))
        }).typeError(t("validation.required"))
            .required(t("validation.required")),
        deliveryDate: Yup.date()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        auctionDate: Yup.date()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
    })
}